import { useTranslation } from 'react-i18next';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import JsonLd from '@/components/feature/JsonLd';
import { siteUrl } from '@/lib/site';
import Hero from './components/Hero';
import CategorySection from './components/CategorySection';
import InfoSections from './components/InfoSections';
import GuidesFaq from './components/GuidesFaq';

export default function Home() {
  const { t } = useTranslation();

  const webSiteData = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'USFans Spreadsheet',
    url: siteUrl('/'),
    description: t('home.metaDescription'),
    inLanguage: 'en',
  };

  const organizationData = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'USFans Spreadsheet',
    url: siteUrl('/'),
  };

  const faqData = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      { '@type': 'Question', name: t('home.faqQ1'), acceptedAnswer: { '@type': 'Answer', text: t('home.faqA1') } },
      { '@type': 'Question', name: t('home.faqQ2'), acceptedAnswer: { '@type': 'Answer', text: t('home.faqA2') } },
      { '@type': 'Question', name: t('home.faqQ3'), acceptedAnswer: { '@type': 'Answer', text: t('home.faqA3') } },
      { '@type': 'Question', name: t('home.faqQ4'), acceptedAnswer: { '@type': 'Answer', text: t('home.faqA4') } },
      { '@type': 'Question', name: t('home.faqQ5'), acceptedAnswer: { '@type': 'Answer', text: t('home.faqA5') } },
    ],
  };

  return (
    <div className="min-h-screen bg-cream text-stone-900">
      <JsonLd data={webSiteData} />
      <JsonLd data={organizationData} />
      <JsonLd data={faqData} />
      <Header />
      <main>
        <Hero />
        <CategorySection />
        <div className="bg-sage/40">
          <InfoSections />
        </div>
        <div className="bg-white">
          <GuidesFaq />
        </div>
      </main>
      <Footer />
    </div>
  );
}